import { emergencyContactListsAdapterSelectors } from '../redux/slices/emergencyContactList';
import { createSelector } from 'reselect';

const getCurrentWorkspaceEmergencyContactListsFromStore = (state) =>
  state.currentWorkspace.emergencyContactLists;

export const currentWorkspaceEmergencyContactLists = createSelector(
  getCurrentWorkspaceEmergencyContactListsFromStore,
  (state) => (id) =>
    emergencyContactListsAdapterSelectors.selectById(state, id),
  (emergencyContactIds, getEmergencyContactById) =>
    emergencyContactIds.map((emergencyContactId) =>
      getEmergencyContactById(emergencyContactId)
    )
);
